module.exports = __webpack_public_path__ + "static/retmes-map-ada190586bf6c37022a987381df5b6b7.svg";